import MediaTemplate from '../../html/components/media.html'
import MediaBodyTemplate from '../../html/components/media-body.html'

import Component from '../shared/component'

export const Media = Component('v-media', {
  template: MediaTemplate,
  props: {
    align: {
      type: String,
      default: 'top',
      validator (value) {
        switch (value) {
          case '':
          case 'top':
          case 'bottom':
          case 'center':
            return true
          default:
            return false
        }
      }
    }
  },
  computed: {
    classes () {
      return {
        [`is-${this.align}`]: this.align
      }
    }
  }
})

export const MediaBody = Component('v-media-body', {
  template: MediaBodyTemplate
})
